// extracted by mini-css-extract-plugin
export default {"fret":"Fret_fret__5lz0K"};